var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Sign Out"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.05273 1.48853C1.05273 1.07431 1.38852 0.738525 1.80273 0.738525H6.67466C7.08888 0.738525 7.42466 1.07431 7.42466 1.48853V3.84573C7.42466 4.05284 7.25677 4.22073 7.04966 4.22073C6.84256 4.22073 6.67466 4.05284 6.67466 3.84573V1.48853H1.80273V10.5114H6.67466V8.25931C6.67466 8.0522 6.84256 7.88431 7.04966 7.88431C7.25677 7.88431 7.42466 8.0522 7.42466 8.25931V10.5114C7.42466 10.9256 7.08888 11.2614 6.67466 11.2614H1.80273C1.38852 11.2614 1.05273 10.9256 1.05273 10.5114V1.48853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.79033 4.14988C8.94157 4.00838 9.17887 4.01627 9.32037 4.1675L10.7956 5.74423C10.9595 5.91931 10.9572 6.19209 10.7906 6.36447L9.31614 7.88945C9.17218 8.03835 8.93478 8.04235 8.78588 7.89839C8.63699 7.75444 8.63299 7.51703 8.77695 7.36814L9.68638 6.42753H4.42261C4.2155 6.42753 4.04761 6.25963 4.04761 6.05253C4.04761 5.84542 4.2155 5.67753 4.42261 5.67753H9.70613L8.77271 4.67992C8.63122 4.52868 8.6391 4.29138 8.79033 4.14988Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/Sign_Out.6e0f370ad2eed22e69ebe0035bc0b095.svg";
export { ForwardRef as ReactComponent };